import { EventEmitter } from '@angular/core';
import { ITEMS_PER_PAGE_OPTIONS, PAGINATION } from '../../services/constant';
var CustomPaginationComponent = (function () {
    function CustomPaginationComponent() {
        this.currentPageChange = new EventEmitter();
        this.itemsPerPageChange = new EventEmitter();
        this.totalItems = 0;
        this.maxSize = PAGINATION.MAX_SIZE;
        this.hideItemsPerPage = false;
        this.rightSide = false;
        this.pageChange = new EventEmitter();
        this.optionChange = new EventEmitter();
        this.itemsPerPageOptions = ITEMS_PER_PAGE_OPTIONS;
        this.currentPageValue = 1;
        this.itemsPerPageValue = PAGINATION.PAGE_SIZE;
    }
    CustomPaginationComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(CustomPaginationComponent.prototype, "currentPage", {
        get: function () {
            return this.currentPageValue;
        },
        set: function (value) {
            this.currentPageValue = value;
            this.currentPageChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomPaginationComponent.prototype, "itemsPerPage", {
        get: function () {
            return this.itemsPerPageValue;
        },
        set: function (value) {
            this.itemsPerPageValue = value;
            this.itemsPerPageChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    return CustomPaginationComponent;
}());
export { CustomPaginationComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/core/pagination/custom-pagination.component.ts.pre-build-optimizer.js